import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__rangeTo_impl_1k0odj1ncwos3p2ntha as MonetaryValue__rangeTo_impl_1k0odj,
  MonetaryValueRange__contains_impl_7d4u172030w1fl7pfl7 as MonetaryValueRange__contains_impl_7d4u17,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { coerceAtLeast3jlgfquiyquc9 as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { assertReactive30c64mz7ckt8m as assertReactive } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { RadioButton1rpamcjl5aybg as RadioButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { validategsg6go7eyi9d as validate } from '../../utils/validation.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../components/MonetaryValueInput.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import {
  FundsRequesthksopls9wk01 as FundsRequest,
  ProjectMessage3vmbacgk5u7x3 as ProjectMessage,
} from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function requestFundsDialog(_this__u8e3s4, project) {
  var tmp = get_dialogStack();
  return tmp.vh2(VOID, VOID, ($this$dialog, close) => {
    var tmp = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(40));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$dialog.pc());
    var tmp0_elvis_lhs = $this$dialog.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
    $this$dialog.gbb(p, view);
    view.zbm(true);
    title(view, 'Request Funds?');
    body(view, 'Requesting funds notifies your client to send a check or wire to Stoze for this project. Choose whether to request the full project amount or a partial amount. The project will move to Pending Start once Stoze receives the requested amount.\n\nBe ready to start soon, and communicate any changes to scope or cost through Stoze to ensure approval and avoid payment issues.');
    var requestFull = Signal().hak(true);
    var partial = validated(Signal().hak(new (MonetaryValue())(Companion_instance.m62(0))));
    var note = Signal().hak('');
    var maxAmount = coerceAtLeast(new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(project.w7b_1, project.a7c_1)), new (MonetaryValue())(Companion_instance.m62(0))).y5r_1;
    var showAllIssues = Signal().hak(false);
    var tmp_0 = 'Amount must be in range ' + MonetaryValue__toString_impl_xslc77(Companion_instance.m62(1)) + ' to ' + MonetaryValue__toString_impl_xslc77(maxAmount);
    assertReactive(partial, tmp_0, VOID, ($this$assertReactive, it) => $this$assertReactive.daj(requestFull) || MonetaryValueRange__contains_impl_7d4u17(MonetaryValue__rangeTo_impl_1k0odj(Companion_instance.m62(1), maxAmount), it.y5r_1));
    bodyBold(view, 'Request Amount');
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.zbm(false);
    var tmp_1 = get_centered(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RadioButton())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.gbb(p_2, view_2);
    view_2.zah(view_2.pc7_1, requestFull);
    view_1.hbb(p_2, view_2);
    view_1.lbb(tmp_1, view_2);
    view_1.lbb(get_centered(view_1), body(view_1, MonetaryValue__compareTo_impl_w7ul1r(project.z7b_1, Companion_instance.m62(0)) > 0 ? 'Remaining project amount \u2013 ' + MonetaryValue__toString_impl_xslc77(maxAmount) : 'Full project amount \u2013 ' + MonetaryValue__toString_impl_xslc77(maxAmount)));
    view_0.hbb(p_1, view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_3 = view_0.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
    view_0.gbb(p_3, view_3);
    view_3.zbm(false);
    var tmp_2 = get_centered(view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RadioButton())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.gbb(p_4, view_4);
    view_4.zah(view_4.pc7_1, equalTo(requestFull, false));
    view_3.hbb(p_4, view_4);
    view_3.lbb(tmp_2, view_4);
    var tmp_3 = view_3.kbb(get_centered(view_3), get_compact(view_3));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_5 = view_3.ebb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
    view_3.gbb(p_5, view_5);
    view_5.zbm(true);
    view_5.bb9(get_rem_0(0.1));
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_4 = view_5.jbb(FieldSemantic_getInstance());
    var tmp_5 = view_5.kbb(tmp_4, validate(view_5, partial, ($this$validate) => $this$validate.daj(showAllIssues) || MonetaryValue__compareTo_impl_w7ul1r($this$validate.daj(partial).y5r_1, maxAmount) > 0));
    // Inline function 'com.crowpay.views.components.monetaryValueInput' call
    // Inline function 'kotlin.also' call
    var this_0 = new (MonetaryValueInput())(view_5);
    var $this$monetaryValueInput = this_0;
    var tmp_6 = KMutableProperty0();
    var tmp_7 = MonetaryValueInput$_get_enabled_$ref_ui2o9t($this$monetaryValueInput);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('enabled', 0, tmp_6, tmp_7, MonetaryValueInput$_set_enabled_$ref_7ohxx($this$monetaryValueInput));
    reactiveScope(view_5, ($this$reactiveScope) => {
      var tmp$ret$11 = !$this$reactiveScope.daj(requestFull);
      this_1.set(tmp$ret$11);
      return Unit_instance;
    });
    $this$monetaryValueInput.vcl('Partial Amount');
    view_5.zah($this$monetaryValueInput.ig9_1, partial);
    reactive(view_5, ($this$reactive) => {
      var tmp;
      if ($this$reactive.daj(requestFull)) {
        partial.oam(new (MonetaryValue())(Companion_instance.m62(0)));
        tmp = Unit_instance;
      } else {
        $this$monetaryValueInput.qb9();
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
    var tmp$ret$15 = this_0.lg9_1;
    view_5.lbb(tmp_5, tmp$ret$15);
    var tmp_8 = get_issues(partial);
    issueText(view_5, tmp_8, VOID, ($this$issueText) => $this$issueText.daj(showAllIssues) || MonetaryValue__compareTo_impl_w7ul1r($this$issueText.daj(partial).y5r_1, maxAmount) > 0);
    view_3.hbb(p_5, view_5);
    view_3.lbb(tmp_3, view_5);
    view_0.hbb(p_3, view_3);
    view.hbb(p_0, view_0);
    label2(view, 'Note to Client (Optional)', 'Your client will see this note when they go to send funds, and a copy will be saved to the project message thread.', ($this$label2) => {
      var tmp = sizeConstraints($this$label2, VOID, VOID, get_rem(5));
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var tmp$ret$28 = $this$label2.jbb(FieldSemantic_getInstance());
      var tmp_0 = $this$label2.kbb(tmp, tmp$ret$28);
      // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (TextArea())($this$label2.pc());
      var tmp0_elvis_lhs = $this$label2.ebb_1;
      var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
      $this$label2.gbb(p, view);
      view.vcl('What are these funds for? Add a note or breakdown.');
      view.zah(view.scl_1, note);
      $this$label2.hbb(p, view);
      return $this$label2.lbb(tmp_0, view);
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (Space())(view.pc());
    var tmp0_elvis_lhs_6 = view.ebb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
    view.gbb(p_6, view_6);
    view.hbb(p_6, view_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_7 = view.ebb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
    view.gbb(p_7, view_7);
    view_7.zbm(false);
    view_7.bb9(get_AppDimensions().kg2_1);
    var tmp_9 = get_primaryButton(view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Button())(view_7.pc());
    var tmp0_elvis_lhs_8 = view_7.ebb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
    view_7.gbb(p_8, view_8);
    specCenteredText(view_8, 'Request Funds');
    onClick(view_8, VOID, VOID, requestFundsDialog$lambda$slambda_0(partial, showAllIssues, project, requestFull, note, close));
    view_7.hbb(p_8, view_8);
    view_7.lbb(tmp_9, view_8);
    var tmp_10 = get_textButton(view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Button())(view_7.pc());
    var tmp0_elvis_lhs_9 = view_7.ebb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
    view_7.gbb(p_9, view_9);
    specCenteredText(view_9, 'Go Back');
    onClick(view_9, VOID, VOID, requestFundsDialog$lambda$slambda_2(close));
    view_7.hbb(p_9, view_9);
    view_7.lbb(tmp_10, view_9);
    view.hbb(p_7, view_7);
    $this$dialog.hbb(p, view);
    return $this$dialog.lbb(tmp, view);
  });
}
function MonetaryValueInput$_get_enabled_$ref_ui2o9t(p0) {
  return () => p0.fbs();
}
function MonetaryValueInput$_set_enabled_$ref_7ohxx(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.pin_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    var tmp_0 = $this.qin_1.iah(true, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return Unit_instance;
  }
  var full = MonetaryValue__minus_impl_jw9qyp($this.rin_1.w7b_1, $this.rin_1.z7b_1);
  var requestAmount = $this.sin_1.f2() ? full : $this.pin_1.f2().y5r_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var session = tmp_1;
  var tmp0_project = $this.rin_1.v7a_1;
  var tmp1_summary = $this.tin_1.f2();
  var tmp2_access = session.wfw();
  var tmp_2 = session.qfw_1.beo(new (FundsRequest())(VOID, tmp0_project, tmp2_access, requestAmount, tmp1_summary), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  // Inline function 'kotlin.text.isNotBlank' call
  var this_2 = $this.tin_1.f2();
  if (!isBlank(this_2)) {
    var tmp_3 = session.lfw_1.lft(new (ProjectMessage())(VOID, $this.rin_1.v7a_1, session.gfv_1, VOID, VOID, false, VOID, 'Funds Requested: ' + MonetaryValue__toString_impl_xslc77(requestAmount) + '\n' + $this.tin_1.f2()), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  $this.uin_1();
  return Unit_instance;
}
var requestFundsDialog$lambda$slambdaClass;
function requestFundsDialog$lambda$slambda() {
  if (requestFundsDialog$lambda$slambdaClass === VOID) {
    class $ {
      constructor($partial, $showAllIssues, $project, $requestFull, $note, $close) {
        this.pin_1 = $partial;
        this.qin_1 = $showAllIssues;
        this.rin_1 = $project;
        this.sin_1 = $requestFull;
        this.tin_1 = $note;
        this.uin_1 = $close;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    requestFundsDialog$lambda$slambdaClass = $;
  }
  return requestFundsDialog$lambda$slambdaClass;
}
function requestFundsDialog$lambda$slambda_0($partial, $showAllIssues, $project, $requestFull, $note, $close) {
  var i = new (requestFundsDialog$lambda$slambda())($partial, $showAllIssues, $project, $requestFull, $note, $close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var requestFundsDialog$lambda$slambdaClass_0;
function requestFundsDialog$lambda$slambda_1() {
  if (requestFundsDialog$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($close) {
        this.vin_1 = $close;
      }
      uao($completion) {
        this.vin_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    requestFundsDialog$lambda$slambdaClass_0 = $;
  }
  return requestFundsDialog$lambda$slambdaClass_0;
}
function requestFundsDialog$lambda$slambda_2($close) {
  var i = new (requestFundsDialog$lambda$slambda_1())($close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  requestFundsDialog as requestFundsDialog11j6g5n16g4u9,
};
//endregion

//# sourceMappingURL=requestFunds.mjs.map
